import React, { ReactNode, useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import NewGNB from '@/app/organisms/NewGNB';
import Footer from '@/app/organisms/NewHome/Footer';
import { useMobileDimensions } from '@app/hooks';

function Layout({
  children,
  themeToggler,
}: {
  children: ReactNode;
  themeToggler: () => void;
}) {
  const [noheader, setNoHeader] = useState(false);
  const [nofooter, setNoFooter] = useState(false);
  const [smallHeader, setSmallHeader] = useState(false);
  const [noFloat, setNoFloat] = useState(false);
  const [noPadding, setNoPadding] = useState(false);
  const { isMobile } = useMobileDimensions();

  const location = useLocation();
  const [searchParams] = useSearchParams();

  const isAppFromUrl = searchParams.get('app') === 'true';

  useEffect(() => {
    if (isAppFromUrl) {
      sessionStorage.setItem('isApp', 'true');
    }
  }, [isAppFromUrl]);

  const isApp = isAppFromUrl || sessionStorage.getItem('isApp') === 'true';

  useEffect(() => {
    const path = location.pathname.split('/')[1] || '';

    // 기본값 초기화: 헤더/푸터 노출, 기본 헤더 사이즈, 플로팅/패딩 허용
    setNoHeader(false);
    setNoFooter(false);
    setSmallHeader(false);
    setNoFloat(false);
    setNoPadding(false);

    // 트레이드 화면: 푸터 숨김, 컴팩트 헤더 및 패딩 조정
    if (
      (path.startsWith('trade') || path.includes('demo-trade')) &&
      !path.includes('copytrade') &&
      !path.includes('trade-competition')
    ) {
      setSmallHeader(true);
      setNoFloat(false);
      setNoFooter(true);
      setNoPadding(true);
      return;
    }

    // Trading Bots 페이지: 다른 페이지와 동일하게 GNB + Footer 사용
  }, [location.pathname]);

  // 모바일에서 avatar 아이콘 숨김
  const hideUserProfile = isMobile;

  return (
    <GlobalContainer>
      {!noheader && !isApp && <NewGNB hideUserProfile={hideUserProfile} />}
      <ContentWrapper $hasHeader={!noheader} $isMobile={isMobile}>
        {children}
      </ContentWrapper>
      {!nofooter && !isApp && (
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      )}
    </GlobalContainer>
  );
}

export default React.memo(Layout);

const GlobalContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const ContentWrapper = styled.div<{
  $hasHeader: boolean;
  $isMobile: boolean;
}>``;

const FooterWrapper = styled.div`
  position: relative;
  z-index: 10;
`;
